export const getSelectedUserModule = (moduleList) => {
    return {
        type: "USER_MODULES",
        payload: moduleList
    };
};
export const getSelectedFarmModule = (farmModules) => {
    return {
        type: "FARM_MODULES",
        payload: farmModules
    };
};
